// BatchList.js placeholderapp.use('/api/batches', batchRoutes);
// src/pages/batches/BatchList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import API_BASE_URL from '../../utils/config';

export default function BatchList() {
  const { user } = useAuth();
  const [batches, setBatches] = useState([]);

  useEffect(() => {
    const fetchBatches = async () => {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/api/batches`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBatches(res.data);
    };
    fetchBatches();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Batches</h2>
        <Link to="/batches/add" className="bg-blue-600 text-white px-4 py-2 rounded">
          Add Batch
        </Link>
      </div>
      <table className="w-full table-auto bg-white shadow rounded">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">ID</th>
            <th className="p-2 text-left">Product</th>
            <th className="p-2 text-left">Batch No</th>
            <th className="p-2 text-left">Expiry</th>
            <th className="p-2 text-left">Quantity</th>
            <th className="p-2 text-left">MRP</th>
            <th className="p-2 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {batches.map((batch) => (
            <tr key={batch.id}>
              <td className="p-2">{batch.id}</td>
              <td className="p-2">{batch.product_name}</td>
              <td className="p-2">{batch.batch_number}</td>
              <td className="p-2">{batch.expiry_date}</td>
              <td className="p-2">{batch.quantity}</td>
              <td className="p-2">{batch.mrp}</td>
              <td className="p-2">
                <Link to={`/batches/edit/${batch.id}`} className="text-blue-600 mr-2">Edit</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
